import { CloseOutlined } from '@ant-design/icons';
import { useState } from 'react';
import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import IconButton from '@/components/Button/IconButton';
import Input from '@/components/Inputs/Input';
import { useModalContext } from '@/components/Modal/Modal';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { modalStyle } from '@/styles/style';

type Props = {
  onConnect?: (subDomain: string) => void;
};

const ZendeskSubdomailModal = ({ onConnect }: Props) => {
  const color = useColor();
  const { closeModal } = useModalContext();
  const [subDomain, setSubDomain] = useState('');

  const onConnectClick = () => {
    if (subDomain.trim() === '') return;
    onConnect?.(subDomain);
    closeModal();
  };
  return (
    <ModalStyle d="column">
      <Flex j="space-between">
        <Heading type="h2">Zendesk Integration</Heading>
        <IconButton
          icon={<CloseOutlined />}
          outlined={false}
          sizeType="l"
          onClick={closeModal}
        />
      </Flex>
      <Space h="24px" />
      <Typo type="label1" weight="m">
        Subdomain
      </Typo>
      <Space h="4px" />
      <Typo type="label2" color={color.gray700}>
        Enter the subdomain of your Zendesk URL.
      </Typo>
      <Space h="4px" />
      <Typo type="body2" color={color.gray700}>
        (ex. https://<b>your-subdomain</b>.zendesk.com)
      </Typo>
      <Space h="16px" />
      <Input
        placeholder="Subdomain"
        sizeType="m"
        value={subDomain}
        onChange={(e) => setSubDomain(e.target.value)}
      />
      <Space h="32px" />
      <Flex j="flex-end">
        <Button
          sizeType="m"
          onClick={onConnectClick}
          disabled={subDomain.trim() === ''}
        >
          Connect
        </Button>
      </Flex>
    </ModalStyle>
  );
};

const ModalStyle = styled(Flex)`
  width: 620px;
  padding: 32px;
  color: ${(props) => props.theme.colors.gray800};
  ${modalStyle};
`;

export default ZendeskSubdomailModal;
